import { catalogApiRef } from "@backstage/plugin-catalog-react";
import { GroupEntity } from '@backstage/catalog-model';
import { mapGroupEntitiesToTeams } from "./teamUtils";
import { useApi } from "@backstage/core-plugin-api";
import useAsync from "react-use/esm/useAsync";
import { useLogger } from "../../utils/logger";
import { useMemo } from "react";

export function useTeamList(departmentGroup?: GroupEntity) {
  const catalogApi = useApi(catalogApiRef);
  const logger = useLogger();

  const { value: allTeams, loading: isLoading } = useAsync(async () => {
    const filter: Record<string, string> = { kind: 'Group' };

    if (departmentGroup) {
      const departmentGroupRef = `group:${departmentGroup.metadata.namespace}/${departmentGroup.metadata.name}`;
      filter['relations.childOf'] = departmentGroupRef;
    }

    const { items } = await catalogApi.getEntities({
      filter: [filter],
    });
    
    return items as GroupEntity[];
  }, [catalogApi, departmentGroup]);

  // TEMPORARY limit to only SCALAR teams
  const teams = useMemo(
    () => mapGroupEntitiesToTeams(allTeams, logger).filter(team => team.division === 'SCALAR'),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [allTeams]
  );

  return {
    teams,
    isLoading,
  };
}
